import { getButtonRowStarter } from './button-row';
import { starterChild } from './slot';
import type { StarterChild } from './slot';

export type HeroStarterChild =
  | StarterChild
  | {
      type: 'ButtonRow';
      props: { content: StarterChild[]; desktopLayout: 'row'; mobileLayout: 'column' };
    };

/**
 * Returns the complete slot tree used by every newly inserted or pre-seeded Hero.
 *
 * The button row starts with two Buttons and accepts only Buttons. Authors can also add Heading,
 * Text, Button and Image children directly to the Hero.
 *
 * IDs are intentionally absent at every level. Puck recursively stamps fresh IDs when a Hero is
 * inserted; pre-seeded page data adds stable IDs in `default-hero.ts` instead.
 */
export function getHeroStarterChildren(): HeroStarterChild[] {
  return [
    starterChild('Heading', {
      text: '<p style="text-align: center">Your headline</p>',
      level: 'h1',
    }),
    starterChild('Paragraph', {
      text: '<p style="text-align: center">Add a short description that supports your headline.</p>',
    }),
    {
      type: 'ButtonRow',
      props: {
        content: getButtonRowStarter(),
        desktopLayout: 'row',
        mobileLayout: 'column',
      },
    },
  ];
}
